import { BaseDialog } from '@/components/dialog/base-dialog'
import { Column, Row } from '@/components/layout/layout'
import { getFullImageurl, getVideoPreviewUrl } from '@/config/qiniu'
import useBemClass from '@/utils/hooks/useBEMClass'
import { layerManage, showLayer } from '@/utils/layer'
import React from 'react'
import { MediaItemType } from './media-edit'
import './media-edit.scss'
import VideoPreview from './video-preivew'


interface MediaPreviewProps {
    val: MediaItemType[]
}

const MediaPreview: React.FC<MediaPreviewProps> = props => {
    const cls = useBemClass('media-edit')

    return (
        <BaseDialog width={390} isShow title="图文详情预览" onClose={() => layerManage.pop()}>
            <Column className={cls('preview-content')}>
                {props.val.map(v => (
                    <Row className={cls('preview-content', 'item')} key={v.$id}>
                        {v.type === 'richText' && <div data-margin-v-12>{v.content}</div>}
                        {v.type === 'bigImage' && <img className="big-image" src={getFullImageurl(v.content) + '?imageView2/2/w/800'} alt="" />}
                        {v.type === 'multiImage' &&
                            v.content.map(c => (
                                <img key={c.$id} className="small-image" src={getFullImageurl(c.url) + '?imageView2/2/w/800'} alt="" />
                            ))}
                        {v.type === 'video' && (
                            <div
                                className="big-image"
                                data-position-relative
                                onClick={() => {
                                    showLayer(<VideoPreview url={v.content} />)
                                }}
                            >
                                <i className={`iconfont ${cls('play-icon')} iconshipin`} />
                                <img className="big-image" src={getVideoPreviewUrl(v.content, 375)} alt="" />
                            </div>
                        )}
                    </Row>
                ))}
            </Column>
        </BaseDialog>
    )
}

export default MediaPreview
